import { render } from "./AjustesOrigen.vue?vue&type=template&id=4860ea81&scoped=true"
import script from "./AjustesOrigen.vue?vue&type=script&lang=js"
export * from "./AjustesOrigen.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./AjustesOrigen.vue?vue&type=style&index=1&id=4860ea81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4860ea81"]])

export default __exports__